
import React, { useState } from "react";
import { Form, Input} from 'antd'
function CheckIn() {
  const onFinish = (values) => {
    console.log('succses:', values);
  }
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  }
  return (
    <div className="booking" id="checkIn">
      <Form
       onFinish={onFinish}
        onFinishFailed={onFinishFailed}>
        <div className="row styleBooking">
          <div className="col-lg-3 col-12">
            <div className="formInput">
              <Form.Item label="Mã nhận phòng" name="roomcode">
                <Input placeholder="Mã nhận phòng" />
              </Form.Item>
            </div>
          </div>
          <div className="col-lg-3 col-12">
            <div className="formInput">
              <Form.Item label="Số đt/email" name="phonenumber_email">
                <Input
                  placeholder="Nhập số ĐT/email"
                />
              </Form.Item>
            </div>
          </div>
          <div className="col-lg-2 col-12 btnSearch">
            <button >
              <img src="images/search.png" alt="" /> Tìm kiếm
            </button>
          </div>
        </div>
      </Form>
      
    </div>
  );
}
export default CheckIn;
